export default {"src":"/_next/static/media/Solution5.6ced0d00.svg","height":49,"width":49};